export default __webpack_public_path__ + "static/media/idaho.d736fcb3.svg";